import React from 'react';

export default class FormLoaderIndicatorComponent extends React.Component {
	render() {
		if (!this.props.loading) {
			return <span></span>;
		}
		return <span className='fa fa-spinner'></span>;
	}
}


// WEBPACK FOOTER //
// ./src/opencell/pages/elements/FormLoaderIndicatorComponent.jsx